var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLogActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35773 1.47329C1.14816 1.8629 -0.327209 3.96995 0.0623977 6.17952L0.140782 6.62405L9.14453 5.03645C10.8151 3.33425 13.1417 2.27818 15.715 2.27764C14.94 0.69146 13.1847 -0.259462 11.3593 0.0623978L3.35773 1.47329Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7072 6.93996C6.94435 8.28116 6.50864 9.83268 6.50865 11.486C6.50865 13.1673 6.95927 14.7434 7.74633 16.1001L5.9914 16.4095C3.78183 16.7991 1.67478 15.3238 1.28517 13.1142L0.42296 8.22437L7.7072 6.93996Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13365 11.486C8.13365 7.29783 11.5288 3.90265 15.717 3.90265C19.9051 3.90265 23.3003 7.29783 23.3003 11.486C23.3003 15.6741 19.9051 19.0693 15.717 19.0693C11.5288 19.0693 8.13365 15.6741 8.13365 11.486ZM15.717 8.23599C16.1657 8.23599 16.5295 8.59975 16.5295 9.04849V11.1494L18.4582 13.0781C18.7755 13.3954 18.7755 13.9099 18.4582 14.2272C18.1409 14.5445 17.6264 14.5445 17.3091 14.2272L15.1425 12.0605C14.9901 11.9081 14.9045 11.7015 14.9045 11.486V9.04849C14.9045 8.59975 15.2682 8.23599 15.717 8.23599Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogActive);
export default __webpack_public_path__ + "static/media/activity_log_active.bc3c4db56238bd256b12c566c6a4d9d9.svg";
export { ForwardRef as ReactComponent };